/* eslint-disable prettier/prettier */

import { createSlice } from '@reduxjs/toolkit'

const paymentReducer = createSlice({
    name: 'paymentReducer',
    initialState: {
        paymentOptions: [],
        paymentOption: '',
        payment: {},
        currentPage:'',
        loading: false,
        paymentCounts:0,
        searchText:{
            name: '',
            startDate: '',
            endDate: '',
            paymentOption: [],
            bookingNo: '',
            invoiceNo: ''
        }
    },
    reducers: {
        setField(state, action) {
            state[action.payload.name] = action.payload.value
        },
     
        setPayment(state, action) {
            state.payment = action.payload
        },
        setSearchText(state, action) {
            state.searchText[action.payload.name] = action.payload.value
        },
       
        clearSearchForm(state, action) {
            state.searchText = {
                name: '',
                startDate: '',
                endDate: '',
                resNo:'',
                invoiceNo: '',
                paymentOption: [],
                bookingNo: '',
            }

        }

    },
});

export const {
     
    setField,
    setSearchText,
    setPayment,
    clearSearchForm,
} = paymentReducer.actions;
export default paymentReducer.reducer;